var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-editor-modal"},[_c('b-modal',{ref:"modal",staticClass:"image-modal",attrs:{"title":_vm.modalTitle,"size":"lg"}},[(_vm.loading)?_c('Pulse',{attrs:{"color":"#999999"}}):_vm._e(),(_vm.image)?_c('img',{attrs:{"src":_vm.imageUrl},on:{"load":_vm.imageLoaded}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }